module.exports = __webpack_public_path__ + "static/img/y3.faacb7c9.svg";